export const baseURL = "https://admin.tokchat.duckdns.org/";
export const key = "5TIvw5cpc0";
export const projectName = "Tok"
